export function getTaraTopicInstructionTimeCell({ topicDrill = false, timed = false, timerDuration } = {}) {
  if (!timed) return 'Untimed';
  if (topicDrill) return `${timerDuration || 40} minutes`;
  return '40 minutes';
}
